/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectCategoryCommand } from '../../models/update-project-category-command';
import { UpdateProjectCategoryCommandResult } from '../../models/update-project-category-command-result';

export interface ApiProjectCategoriesUpdateProjectCategoryPatch$Plain$Params {
  
    /**
     * The details of the Project Category to update.
     */
    body?: UpdateProjectCategoryCommand
}

export function apiProjectCategoriesUpdateProjectCategoryPatch$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectCategoriesUpdateProjectCategoryPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectCategoryCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectCategoriesUpdateProjectCategoryPatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectCategoryCommandResult>;
    })
  );
}

apiProjectCategoriesUpdateProjectCategoryPatch$Plain.PATH = '/api/ProjectCategories/UpdateProjectCategory';
